<div *ngIf="!blockButton">
  <div *ngIf="menuitems.length > 1">
    <button nbButton size="medium" status="primary" shape="semi-round" [nbContextMenu]="menuitems" [aria-label]="add_label || 'Add Item'" [disabled]="disabled" [nbContextMenuTag]="'add-item-menu-' + instance">
      <span *ngIf="use_icon" [nbTooltip]="add_label">
        <nb-icon pack="fas" icon="plus"></nb-icon>
      </span>
      <span *ngIf="!use_icon">{{add_label || 'add_item'| translation}}</span>
    </button>
  </div>
  <div *ngIf="menuitems.length === 1">
    <button nbButton size="medium" shape="semi-round" status="primary" nbTooltip="{{'add'|translation}} {{menuitems[0].title}}" aria-label="Add Item" (click)="addItem(menuitems[0])" [disabled]="disabled">
      <span *ngIf="use_icon" title="{{menuitems[0].title || add_label}}">
        <nb-icon pack="fas" icon="plus"></nb-icon>
      </span>
      <span *ngIf="!use_icon">{{menuitems[0].title || add_label}}</span>
    </button>
  </div>
</div>
<div class="scaffold-create-button" *ngIf="blockButton">
  <div *ngIf="menuitems.length > 1">
    <button nbButton appearance='ghost' status="info" size="large" [nbContextMenu]="menuitems" [disabled]="disabled">
      <span *ngIf="use_icon" class="create-button-icon">
        <nb-icon pack="fas" icon="plus"></nb-icon>
      </span>
      <span class="create-button-heading">{{add_label}}</span>
    </button>
  </div>
  <div *ngIf="menuitems.length === 1">
    <button nbButton appearance='ghost' status="info" size="large" (click)="addItem(menuitems[0])" [disabled]="disabled">
      <span *ngIf="use_icon" class="create-button-icon">
        <nb-icon pack="fas" icon="plus"></nb-icon>
      </span>
      <span class="create-button-heading">{{add_label}}</span>
    </button>
  </div>
</div>
